import axiosInstance from './interceptors';

export default axiosInstance;
